export default function SortDownIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 12}
      height={height ? height : width ? width : 12}
      viewBox="0 0 48 48"
    >
      <g fill="currentColor" fillRule="nonzero">
        <path
          d="M10.735 27.38H36.77c2.34 0 3.511 2.833 1.86 4.484L25.611 44.882a2.615 2.615 0 0 1-3.708 0L8.875 31.864c-1.652-1.651-.481-4.485 1.86-4.485Z"
          opacity=".2"
        />
        <path d="M38.63 15.893 25.612 2.875a2.615 2.615 0 0 0-3.708 0L8.875 15.893c-1.652 1.652-.481 4.485 1.86 4.485H36.77c2.34 0 3.511-2.833 1.86-4.485Z" />
      </g>
    </svg>
  );
}
